import { render, staticRenderFns } from "./fBadge.template?vue&type=template&id=22f2015a&lang=pug&"
import script from "./fBadge.client?vue&type=script&lang=ts&"
export * from "./fBadge.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f2015a')) {
      api.createRecord('22f2015a', component.options)
    } else {
      api.reload('22f2015a', component.options)
    }
    module.hot.accept("./fBadge.template?vue&type=template&id=22f2015a&lang=pug&", function () {
      api.rerender('22f2015a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fBadge/fBadge.component.vue"
export default component.exports